import { decode } from 'html-entities';

const decodeHTML = (html) => {
  if (!html) return html;
  
  // Use html-entities library
  const decoded = decode(html);
  
  return decoded;
};

export default decodeHTML;
